import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { setReasonsRefusal } from '../../store/ducks/reasonRefusal/action';

export default function useGetReasonsRefusal() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute({
    page,
    rowsPerPage,
  }: {
    page?: number;
    rowsPerPage?: number;
  }) {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/reasons-refusal', {
        params: {
          rowsPerPage: rowsPerPage || 20,
          page: page || 1,
        },
      });

      if (response.status === 200) {
        dispatch(setReasonsRefusal(response.data));
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
